// extracted by mini-css-extract-plugin
export default {"root":"SocialIcon_root__VlFMA"};